import { defineComponent } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

import { IEmployeeList, IReassignVisitDetails } from "../../../vue-interfaces/i-reassign-visit";
import { ITypeaheadOptions } from "../../../vue-interfaces/i-typeahead";
import { formatDateFromDate } from "../../../../common/vue-helpers/modifiers/value-modifier";

import FormSection from "../../../vue-custom-elements/FormSection/FormSection.vue";
import TypeaheadInput from "../../../vue-custom-elements/TypeaheadInput/TypeaheadInput.vue";
import SaveNotifyUser from "../../../vue-custom-elements/SaveNotifyUser/SaveNotifyUser.vue";

export default defineComponent({
    props: {
        visitDetails: { type: Object, default: {} as IReassignVisitDetails },
        employeeList: { type: Object, default: [] as IEmployeeList[] },
        isLoading: { type: Boolean, default: false },
        isSaving: { type: Boolean, default: false },
        cancel: { type: Function },
        reassign: { type: Function },
        preSelectedEmpId: { type: String, default: null }
    },

    components: {
        FormSection,
        TypeaheadInput,
        SaveNotifyUser
    },

    async created() {
        Object.assign(this.visitDetails, {});
        this.visitDetails.EmpId = null;
    },

    watch: {
        employeeList: function () {
            if (this.preSelectedEmpId) {
                this.selectedEmployee(this.preSelectedEmpId);
                this.visitDetails.EmpId = this.preSelectedEmpId;
            }
        },
        scheduleEmployee(newValue: ITypeaheadOptions) {
            if (!!newValue) {
                this.visitDetails.EmpId = newValue.value;
                const employeeDetails = this.employeeList.find((emp: any) => {
                    return emp.id == newValue.value;
                });
                this.visitDetails.Employee = employeeDetails;
            }
        }
    },

    data() {
        return {
            isReassignSaving: false,
            scheduleEmployee: {} as ITypeaheadOptions,
            formatDateFromDate,
            v$: useVuelidate()
        };
    },

    validations() {
        return {
            scheduleEmployee: { required }
        };
    },

    methods: {
        formatTime(dateTime: Date) {
            return dateTime
                ? new Date(dateTime).toLocaleTimeString("en-us", {
                      hour: "2-digit",
                      minute: "2-digit"
                  })
                : new Date(this.visitDetails.StartDate).toLocaleTimeString("en-us", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit"
                  });
        },

        selectedEmployee(employeeId: string) {
            if (!!employeeId) {
                const employeeDetails = this.employeeList.find((emp: any) => {
                    return emp.id == employeeId;
                });
                this.visitDetails.Employee = employeeDetails;
            }
        },

        employeeListFilter(filter: string) {
            if (filter) {
                const filterEmployeeList = this.employeeList.filter((employee: any) => {
                    const fullName = `${employee.firstName} ${employee.lastName}`;
                    return fullName.toLowerCase().includes(filter.toLowerCase());
                });
                return filterEmployeeList?.map((item: any) => {
                    return {
                        name: `${item.firstName} ${item.lastName}`,
                        value: item.id
                    };
                });
            } else {
                return this.employeeList?.map((item: any) => ({
                    value: item.id,
                    name: `${item.firstName} ${item.lastName}`
                }));
            }
        },

        changescheduleEmployee(data: any) {
            this.scheduleEmployee = data;
        },

        async reassignVisit(notifyUser: boolean = false) {
            try {
                if (this.preSelectedEmpId !== this.visitDetails?.EmpId) {
                    const valid = await this.v$.$validate();
                    if (!valid) {
                        return;
                    }
                }
                const reassignDetails = Object.assign({}, this.visitDetails);
                console.log("visitDetails", this.visitDetails);

                if (notifyUser) {
                    reassignDetails.NotifyUser = true;
                    reassignDetails.PatientName = `${this.visitDetails.FirstName} ${this.visitDetails.LastName}`;
                    reassignDetails.VisitDate = this.formatDateFromDate(
                        this.visitDetails.StartDateTime || this.visitDetails.StartDate
                    );
                    reassignDetails.VisitTime = this.formatTime(
                        this.visitDetails.StartDateTime || this.visitDetails.StartTime
                    );
                }
                await this.reassign(reassignDetails);
            } catch (error) {
                console.error(error);
            }
        }
    }
});
